import { QUERIES } from '@repo/ui/queries';
import styled from 'styled-components';

export const ImageRow = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  gap: 24px;
  img {
    height: 50px;
  }

  ${QUERIES.largeTabletAndUp} {
    gap: 70px;
    img {
      height: 90px;
    }
  }
`;

export const ImageDefault = styled.img`
  display: block;
  html[data-theme='dark'] &&,
  .dark && {
    display: none;
  }
`;

export const ImageDark = styled.img`
  display: none;
  html[data-theme='dark'] &&,
  .dark && {
    display: block;
  }
`;
